import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 好友 ", -1)
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "main-view" }

import { ref,watch } from "vue";
import User from "@/mode/User";
import Top from "@/components/Top.vue";
import ListItem from "@/components/ChatItem.vue";
import AddFriend from "@/components/AddFriend.vue";
import FriendApi from "@/api/FriendApi";
import AccountApi from "@/api/AccountApi";
import { useRoute, useRouter } from "vue-router";
import { useUserStore } from "@/store/userStore";



export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useUserStore();
const friends = ref(new Array<User>());
const checkIndex = ref(-1);
const showAddFriend = ref(false);
const showFriends = ref(new Array<User>());

const search = ()=>{
  let searchName = document.getElementById("searchName").value
  showFriends.value = friends.value.filter(item=>item.name.includes(searchName))
}


const id = store.getUser()?.id;
if (!id) {
  AccountApi.toLogin();
}

const choose = (index: number, id: string) => {
  checkIndex.value = index;
  router.push("/index/friend/" + id);
};

const close = () => {
  showAddFriend.value = false;
  loadFriends();
};

const loadFriends = () => {
  friends.value.splice(0, friends.value.length);
  if (typeof id !== "undefined") {
    FriendApi.friends().then((res: any) => {
      res.data.forEach((item: User) => {
        friends.value.push(item);
      });
    });
  }
  showFriends.value = friends.value;
};

const delFriend = (friendId: string) => {
  if (typeof id !== "undefined") {
    FriendApi.delete(friendId).then(() => {
      loadFriends();
    });
  }
};

loadFriends();

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 14 }, {
              default: _withCtx(() => [
                _createElementVNode("input", {
                  style: {"width":"100%"},
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (search())),
                  id: "searchName",
                  placeholder: "名字搜索"
                }, null, 32)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 4,
              class: "add"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "iconfont icon-v-add",
                  title: "加好友",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showAddFriend.value = !showAddFriend.value), ["stop"]))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(AddFriend, {
          dialogVisible: showAddFriend.value,
          onClose: close
        }, null, 8, ["dialogVisible"])
      ]),
      _createVNode(_component_el_scrollbar, { class: "list" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showFriends.value, (user, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: user.id
            }, [
              _createVNode(ListItem, {
                id: user.id,
                img: user.avatar,
                username: user.name,
                active: index === checkIndex.value,
                showDel: true,
                onDel: ($event: any) => (delFriend(user.id)),
                onClick: ($event: any) => (choose(index, user.id))
              }, null, 8, ["id", "img", "username", "active", "onDel", "onClick"])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Top),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createBlock(_component_router_view, {
          class: "content",
          key: _unref(route).params.id
        }, {
          default: _withCtx(({ Component }) => [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ], 1024))
          ]),
          _: 1
        }))
      ])
    ])
  ]))
}
}

})